import { tagIds } from '../constants/product';

export function isMysteryBox(product) {
  if (!product) {
    return false;
  }

  const tags = product.tagIds || product.tagIdList;
  return tags?.includes(tagIds.MYSTERY_BOX);
}
